module.exports = __webpack_public_path__ + "static/Brass_Dragon-02cb8b23fa9c6d9e8d8e125b5c66518e.jpg";